import { TabData, TabName, TabState } from 'components/CPDashboardTab/types';

export const defaultTabsConfig: TabData[] = [
  {
    name: TabName.CRITICAL,
    amount: 0,
    state: TabState.ACTIVE,
  },
  {
    name: TabName.WILL_BE_UNLINKED,
    amount: 0,
    state: TabState.INACTIVE,
  },
];
